// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop-ranking-query .shop-info .title[data-v-153c75c7] {\n  width: 100px;\n  text-align: right;\n}\n.shop-ranking-query .shop-info .shop-name[data-v-153c75c7] {\n  width: 350px;\n}\n", ""]);
// Exports
module.exports = exports;
